import { LOCALE, TIMEZONE_NAME } from '@data/constants';

function formatDate(date: Date, locales: string[], timeZone: string) {
	const formatter = Intl.DateTimeFormat(locales, {
		month: 'short',
		day: 'numeric',
		year: 'numeric',
		timeZone,
	});

	return formatter.format(date);
}

function formatRelativeDate(date: Date, locales: string[]) {
	if (!Intl.RelativeTimeFormat) {
		return undefined;
	}

	const formatter = new Intl.RelativeTimeFormat(locales, {
		style: 'long',
		numeric: 'auto',
	});

	// How much time ago
	const milliseconds = Date.now() - date.getTime();
	const seconds = Math.round(milliseconds / 1000);
	const minutes = Math.round(seconds / 60);
	const hours = Math.round(minutes / 60);
	const days = Math.round(hours / 24);
	const weeks = Math.round(days / 7);
	const months = Math.round(weeks / 4);

	if (months > 0) {
		return formatter.format(-months, 'month');
	} else if (weeks > 0) {
		return formatter.format(-weeks, 'week');
	} else if (days > 0) {
		return formatter.format(-days, 'day');
	} else if (hours > 0) {
		return formatter.format(-hours, 'hour');
	} else if (minutes > 0) {
		return formatter.format(-minutes, 'minute');
	}

	return undefined;
}

type DateTimeProps = {
	className?: string;
	date: Date;
	isRelative?: boolean;
};

export const DateTime = ({
	className,
	date,
	isRelative = true,
}: DateTimeProps) => {
	const locales = [LOCALE];
	const timeZone = TIMEZONE_NAME;

	const formattedDate = formatDate(date, locales, timeZone);
	const formattedRelativeDate = formatRelativeDate(date, locales);

	const textContent =
		isRelative && formattedRelativeDate ? formattedRelativeDate : formattedDate;

	return (
		<time className={className} dateTime={date.toISOString()}>
			{textContent}
		</time>
	);
};
